module.exports = __webpack_public_path__ + "static/media/not_allowed_piggly_400.c53dad2b.png";